import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useLeadStat = (props: { id?: number } = {}) =>
  useQuery<crmModels.IStats>(
    [crmConstants.queryKeys.LEAD_STAT, props?.id],
    async () => {
      const res = await $api.get(`/v1/lead/stat/${props?.id}`);

      return res?.data?.data;
    },
    {
      enabled: !!props?.id
    }
  );
